import { environment } from '../../../environments/environment';

/**
 * Servizio di logging personalizzato
 * Stub base - sostituire con l'implementazione completa quando disponibile
 */
export class Console {
  private static logLevel: 'info' | 'warn' | 'err' | 'debug' = 'info';

  /**
   * Log di informazioni generali
   */
  static log(label: string, message: any, level: 'info' | 'warn' | 'err' | 'debug' = 'info'): void {
    if (!environment.ENABLE_CONSOLE_LOGS) {
      return;
    }

    const timestamp = new Date().toLocaleTimeString();
    const prefix = `[${timestamp}] [${level.toUpperCase()}] ${label}`;

    switch (level) {
      case 'err':
        console.error(prefix, message);
        break;
      case 'warn':
        console.warn(prefix, message);
        break;
      case 'debug':
        console.debug(prefix, message);
        break;
      default:
        console.log(prefix, message);
    }
  }

  /**
   * Log di errore
   */
  static error(label: string, message: any): void {
    this.log(label, message, 'err');
  }

  /**
   * Log di warning
   */
  static warn(label: string, message: any): void {
    this.log(label, message, 'warn');
  }

  /**
   * Log di debug
   */
  static debug(label: string, message: any): void {
    this.log(label, message, 'debug');
  }
}
